<template>
  <div class="">
    <vue-headful :title="doctitle" />

    <div class="bg-color-dark">
      <div v-if="this.sessionname" class="session-single container py-5">
        <div class="row mt-5 justify-content-md-center">
          <div class="col-md-8 col-sm-12">
            <h1 class="mt-3 mb-3 text-color-light mt-4">
              {{ this.session.sessionTitle }}
            </h1>
            <div class="text-left session-text text-color-light">
              <h5>Key takeaways</h5>
              <ul class="dashed">
                <li v-if="session.sessionKeyTakeAway1">
                  {{ session.sessionKeyTakeAway1 }}
                </li>
                <li v-if="session.sessionKeyTakeAway2">
                  {{ session.sessionKeyTakeAway2 }}
                </li>
                <li v-if="session.sessionKeyTakeAway3">
                  {{ session.sessionKeyTakeAway3 }}
                </li>
                <li v-if="session.sessionKeyTakeAway4">
                  {{ session.sessionKeyTakeAway4 }}
                </li>
              </ul>
              <!--    <p>
                {{ session.sessionDescription }}
              </p> -->

              <div v-html="session.sessionDescription"></div>
              <div v-if="session.sessionVideoURL" class="video embed">
                <iframe
                  :src="session.sessionVideoURL"
                  width="100%"
                  height="360"
                  frameborder="0"
                  allow="autoplay; fullscreen"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <a
              v-if="session.sessionSpeakerURL"
              v-bind:href="'/line-up/' + session.sessionSpeakerURL"
            >
              <img
                class="mt-4 position-relative"
                v-if="session.sessionSpeakerImagePuId"
                v-bind:src="
                  'https://res.cloudinary.com/oredev/image/upload/e_grayscale/q_auto,g_face,r_max,c_thumb,w_220,h_220,b_rgb:292929/v1/' +
                  session.sessionSpeakerImagePuId
                "
                style="z-index: 10"
                alt=""
              />
            </a>
            <h5 class="mt-4">
              <a
                v-if="session.sessionSpeakerURL"
                v-bind:href="'/line-up/' + session.sessionSpeakerURL"
                >{{ this.session.sessionSpeakerName }}</a
              >
            </h5>
            <span v-for="speaker in this.session.otherSpeakersShow">
              <span v-if="speaker">
                <a
                  v-if="speaker.speakerURL"
                  v-bind:href="'/line-up/' + speaker.speakerURL"
                >
                  <img
                    class="mt-4"
                    v-if="speaker.speakerImagePuId"
                    v-bind:src="
                      'https://res.cloudinary.com/oredev/image/upload/e_grayscale/e_colorize:30,co_rgb:7246C1/q_auto,g_face,r_max,c_thumb,w_220,h_220,b_rgb:1a193a/v1/' +
                      speaker.speakerImagePuId
                    "
                    alt=""
                  />
                </a>
                <h5 class="mt-4">
                  <a
                    v-if="speaker.speakerURL"
                    v-bind:href="'/line-up/' + speaker.speakerURL"
                    >{{ speaker.speakerFirstName }}
                    {{ speaker.speakerLastName }}</a
                  >
                </h5>
              </span>
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="this.status != 'sessions'"
        class="container tags-container pt-4"
      >
        <h1 class="big-headline mt-5 mb-5 text-color-light">
          Pick a topic. Sharpen your skills. <br />
          Explore
        </h1>
        <div v-if="loadtags" class="row justify-content-center loading-tags">
          <c-spinner></c-spinner>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-12 text-right select-all">
              <span
                class="select text-color-light"
                v-if="this.tags.length !== this.tagschoosen.length"
                v-on:click="selectAllTags()"
              >
                Select all
              </span>
              <span
                v-if="
                  this.tagschoosen.length > 0 &&
                  this.tags.length !== this.tagschoosen.length
                "
              >
                |
              </span>
              <span
                class="select text-color-light"
                v-if="this.tagschoosen.length > 0"
                v-on:click="deselectAllTags()"
              >
                Deselect all
              </span>
            </div>
            <div class="tags row col-12">
              <div
                class="col-lg-2 col-md-3 col-sm-4 col-xs-6"
                v-for="tag in tags"
                :key="tag.index"
              >
                <div
                  v-on:click="setTag(tag)"
                  v-bind:class="[setActiveTag(tag)]"
                  class="tag text-center text-color-light"
                >
                  {{ tag.org }}
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center confirm-tags pb-5">
            <a
              v-on:click="setStatus('sessions')"
              v-bind:class="[setActiveNext()]"
              class="btn btn-1 show-sessions"
              ><i class="material-icons">done</i></a
            >
          </div>
        </div>
      </div>
    </div>

    <!---------------------------- SESSIONS --------------------------------------->

    <div v-if="this.status === 'sessions'">
      <div :class="isMobile ? '' : 'background pt-5'">
        <div :class="isMobile ? 'background-mobile ' : ''">
          <div class="container">
            <h1
              class="big-headline text-color-dark"
              :class="isMobile ? 'pt-5' : 'mt-5'"
            >
              Pick a topic. Sharpen your skills. <br />
              Explore
            </h1>
            <div class="row mt-5">
              <div class="col-12 tags-choosen">
                <div
                  class="tags-add text-center"
                  @click="selectAllTags()"
                  :class="
                    tagschoosen.length === tags.length ? 'disabled-all' : ''
                  "
                >
                  <small>All</small>
                </div>
                <div
                  class="tags-add text-center pl-0 pr-0"
                  :class="tagschoosen.length === 0 ? 'disabled-all' : ''"
                  href="#"
                  v-on:click="deselectAllTags()"
                >
                  <small>Clear</small>
                </div>

                <div class="tags d-flex flex-wrap">
                  <div
                    class="tag-choosen text-center"
                    v-for="tag in tags"
                    :key="tag.index"
                    @click="setTag(tag)"
                    v-bind:class="[setActiveTag(tag)]"
                  >
                    <span>{{ tag.org }} </span>
                  </div>
                </div>
                <!--  <div
                  v-for="tag in tagschoosen"
                  class="tag-choosen text-center active"
                  :key="tag.index"
                  style="cursor: default"
                >
                  <span>{{ tag.org }}</span>
                  <i
                    class="material-icons pr-2 pl-2"
                    @click="setTag(tag)"
                    style="cursor: pointer"
                    >clear</i
                  >
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="bg-color-dark"
          style="margin-bottom: 50px"
          :style="isMobile ? '' : 'margin-top: 50px;'"
        >
          <div class="bg-color-dark container">
            <div class="row days pt-4 pb-3">
              <div class="col-6 workshop">
                <div
                  class="d-flex text-color-light position-relative"
                  style="z-index: 1000"
                >
                  <span
                    v-on:click="setDay('day3')"
                    v-bind:class="setActiveDay('day3')"
                    id="DayLink-2"
                    class="days-headline pr-3"
                    role="button"
                    >Wed</span
                  >
                  <span
                    v-on:click="setDay('day4')"
                    v-bind:class="setActiveDay('day4')"
                    id="DayLink-3"
                    class="days-headline pr-3"
                    role="button"
                    >Thu</span
                  >

                  <span
                    v-on:click="setDay('day5')"
                    v-bind:class="setActiveDay('day5')"
                    id="DayLink-4"
                    class="days-headline pr-3"
                    role="button"
                    >Fri</span
                  >
                </div>
                <small class="text-color-light">Conference day</small>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <small class="float-right font-italic text-color-light"
                  >Add sessions to create your own schedule
                </small>
              </div>
            </div>
            <div v-if="tagschoosen.length == 0" class="pt-3 pb-5">
              <b-row>
                <b-col cols="12">
                  <h6 class="text-color-light text-center">
                    Game over, select tracks to see sessions
                    <a
                      @click="selectAllTags()"
                      href="#"
                      rel="noopener noreferrer"
                      >(show all)</a
                    >
                  </h6>
                  <div class="d-flex align-items-center justify-content-center">
                    <img
                      style="max-width: 50%; cursor: pointer"
                      src="https://res.cloudinary.com/oredev/image/upload/v1680286129/2023_web/Start-over-animation.gif"
                      alt=""
                      @click="selectAllTags(), scrollToTop()"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="sessions row">
              <div
                v-if="loadsessions"
                class="col-12 mt-5 justify-content-center text-center"
              >
                <b-spinner variant="info"></b-spinner>
              </div>
              <div v-else class="container">
                <div
                  :class="[
                    setVisibleSchedule(
                      session.sessionTagMain,
                      session.sessionTags,
                      session.sessionScheduleDay
                    ),
                    setActiveSchedule(session._id),
                    session.sessionTagMain,
                    session.sessionTags,
                    'day' + session.sessionScheduleDay,
                  ]"
                  class="row session"
                  v-for="session in sessions"
                  :key="session.index"
                >
                  <!-- <div class="col-lg-1 col-10 order-1 order-lg-1 time">
              <h5 class="mt-4">{{ session.sessionScheduleTime }}</h5>
            </div> -->
                  <div class="col-lg-9 col-8 main">
                    <div class="speaker">
                      <span>{{ session.sessionScheduleTime }}</span>
                      <span v-on:click="showSpeaker(session.sessionSpeakerURL)">
                        |
                        {{ session.sessionSpeakerName }}
                      </span>
                      <span v-for="speaker in session.otherSpeakersShow">
                        <span
                          v-if="speaker"
                          v-on:click="showSpeaker(speaker.speakerURL)"
                          >& {{ speaker.speakerFirstName }}
                          {{ speaker.speakerLastName }}
                        </span>
                      </span>
                      <span v-on:click="showMap(session.sessionScheduleRoom)">
                        | Room: {{ session.sessionScheduleRoom }}
                      </span>
                      <!-- <span> | Tracks: {{ session.sessionTagMain }} </span> -->
                    </div>
                  </div>
                  <div
                    class="col-lg-3 col-4 add-schedule text-sm-right"
                    v-on:click="setSchedule(session._id, $event)"
                  >
                    <b-button
                      class="btn btn-1 add mt-2"
                      :class="setActiveSchedule(session._id, true)"
                      >{{ addOrRemove(session._id) }}</b-button
                    >

                    <!-- <i class="material-icons h2 align-middle add green"
                >add_circle_outline</i
              >
              <i class="material-icons h2 align-middle remove pink"
                >remove_circle_outline</i
              > -->
                  </div>
                  <div class="">
                    <div
                      v-on:click="toggleText(session._id)"
                      class="col-11 session-info pb-3"
                    >
                      <h5 class="pt-2">
                        <span class="fold-icons"
                          ><i
                            :data-id="session._id"
                            class="material-icons hidden align-middle pink"
                            >unfold_less</i
                          ><i
                            :data-id="session._id"
                            class="material-icons align-middle pink"
                            >unfold_more</i
                          ></span
                        >
                        <span class="session-title pink pl-3">
                          {{ session.sessionTitle }}
                        </span>
                      </h5>
                    </div>
                  </div>
                  <div
                    :data-id="session._id"
                    class="col-md-12 session-text hidden"
                  >
                    <h4 class="session-title">Key takeaways</h4>
                    <ul class="dashed">
                      <li v-if="session.sessionKeyTakeAway1">
                        {{ session.sessionKeyTakeAway1 }}
                      </li>
                      <li v-if="session.sessionKeyTakeAway2">
                        {{ session.sessionKeyTakeAway2 }}
                      </li>
                      <li v-if="session.sessionKeyTakeAway3">
                        {{ session.sessionKeyTakeAway3 }}
                      </li>
                      <li v-if="session.sessionKeyTakeAway4">
                        {{ session.sessionKeyTakeAway4 }}
                      </li>
                    </ul>

                    <p class="mt-3" v-html="session.sessionDescription"></p>

                    <div v-if="session.sessionVideoURL" class="video embed">
                      <iframe
                        :src="session.sessionVideoURL"
                        width="100%"
                        height="360"
                        frameborder="0"
                        allow="autoplay; fullscreen"
                        allowfullscreen
                      ></iframe>
                    </div>
                    <div class="open-in-new">
                      <a
                        target="_blank"
                        v-if="session.sessionURL"
                        v-bind:href="'/sessions/' + session.sessionURL"
                      >
                        <i class="material-icons">open_in_new</i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-1"
      src="https://res.cloudinary.com/oredev/image/upload/v1679424057/2023_web/shapes%20lp/white-shape-1.png"
    />
    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-2"
      src="https://res.cloudinary.com/oredev/image/upload/v1683012353/2023_web/white-shape-2.png"
    />
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1679424058/2023_web/shapes%20lp/white-shape-5.png"
      class="d-none d-xl-block position-absolute"
      id="white-shape-3"
    />
    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-4"
      src="https://res.cloudinary.com/oredev/image/upload/v1680087567/2023_web/shapes%20info/white-shape-3.png"
      alt="rectangle"
    />

    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-6"
      src="https://res.cloudinary.com/oredev/image/upload/v1680088576/2023_web/shapes%20info/white-shape-6.png"
      alt="rectangle"
    />
    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-7"
      src="https://res.cloudinary.com/oredev/image/upload/v1680090042/2023_web/shapes%20info/white-shape-5.png"
      alt="rectangle"
    />
    <img
      class="d-none d-xl-block position-absolute"
      id="white-shape-8"
      src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
      alt="rectangle"
    />

    <img
      class="rectangle-long-1 position-absolute"
      src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
    />

    <img
      class="rectangle-green-short position-absolute"
      id="green-2"
      src="https://res.cloudinary.com/oredev/image/upload/v1679666601/2023_web/shapes%20info/Blue-shape-1.png"
      alt="rectangle"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-3"
      src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
      alt="rectangle"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-4"
      src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
      alt="rectangle"
    />
    <!-- here -->
    <img
      class="rectangle-orange position-absolute"
      id="orange-3"
      src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-5"
      src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
      alt="rectangle"
    />
    <img
      class="rectangle-orange position-absolute"
      id="orange-4"
      src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
    />
    <img
      class="rectangle-green-short position-absolute"
      id="green-6"
      src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
      alt="rectangle"
    />
    <c-map></c-map>
  </div>
</template>

<script>
import { tagsMixin } from "../mixins/tagsMixin";
import Spinner from "./spinner/Spinner";
import Map from "./map/Map";

export default {
  name: "sessions",
  components: {
    "c-spinner": Spinner,
    "c-map": Map,
  },
  computed: {
    isMobile() {
      if (this.windowWidth <= 1150) {
        return true;
      }
      return false;
    },
  },
  watch: {
    $route(to, from) {
      this.sessionname = this.$route.params.name;

      this.getSession();
    },
  },
  data() {
    return {
      sessions: [],
      loadsessions: true,
      doctitle: "Sessions - " + this.$store.state.conferencename,
      sessionname: this.$route.params.name,
      session: {},
      windowWidth: window.innerWidth,
    };
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  created() {
    window.addEventListener("resize", this.handleResize);

    this.getSession();
    if (localStorage.getItem("schedule")) {
      this.schedule = JSON.parse(localStorage.getItem("schedule"));
    }
  },

  mixins: [tagsMixin],
  methods: {
    getSession: function () {
      if (this.sessionname) {
        this.axios
          .get("https://admin.oredev.org/plannedsession/" + this.sessionname, {
            params: {
              //ID: 12345
            },
          })
          .then((response) => {
            this.session = response.data.plannedsessions[0];

            this.session.sessionDescription =
              response.data.plannedsessions[0].sessionDescription.replaceAll(
                "\n",
                "<br>"
              );
            this.session.sessionDescription =
              response.data.plannedsessions[0].sessionDescription.replaceAll(
                "**",
                ""
              );

            //$(".speaker-single").slideDown(200);
            //this.loadspeakername = false;
            //this.setDocTags();
            return;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    setVisibleSchedule: function (tag, tags, day) {
      let show = false;
      let tagschoosen = this.tagschoosen;

      let containsTag = false;
      if (tagschoosen) {
        containsTag = tagschoosen.some(
          (element) => this.fixTag(element) === tag
        );
      }

      if (tags && !containsTag) {
        tags.forEach((tag) => {
          if (
            tagschoosen.some(
              (element) => this.fixTag(element) === this.fixTag(tag)
            )
          ) {
            containsTag = true;
          }
        });
      }
      if (containsTag && this.day === "day" + day) {
        show = true;
      }
      if (show) {
        return "show";
      } else {
        return "hidden";
      }
    },
    setDay: function (day) {
      if (!day) {
        day = "day1";
      }
      localStorage.setItem("day", day);
      this.day = day;
      this.setUrlHasch("day");
    },
    setActiveDay: function (day) {
      const selDay = this.day;
      if (day === selDay) {
        return "active";
      }
    },
    getVideoId: function (url) {
      const parts = url.split("/");
      return parts[parts.length - 1];
    },
    fetchSessions: function () {
      let that = this;
      this.axios
        .get("https://admin.oredev.org/plannedschedules/Øredev 2023", {
          params: {
            //ID: 12345
          },
        })
        .then((response) => {
          let sessions = response.data.plannedsessions
            .map(function (session) {
              if (session.sessionTags) {
                session.sessionTags = session.sessionTags.map(function (tag) {
                  tag = that.fixTag(tag);
                  return tag;
                });
              }

              session.sessionTagMain = that.fixTag(session.sessionTagMain);

              session.sessionDescription =
                session.sessionDescription.replaceAll("\n", "<br>");
              session.sessionDescription =
                session.sessionDescription.replaceAll("**", "");

              return session;
            })
            .sort(
              (a, b) =>
                parseInt(a.sessionScheduleSlot) -
                parseInt(b.sessionScheduleSlot)
            );

          this.sessions = sessions;
          that.loadsessions = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  updated: function () {},
  mounted: function () {
    this.status = localStorage.getItem("sessionstatus");
    this.day = localStorage.getItem("day");
    this.setTagsChoosen();
    //this.setDay(this.$route.hash.replace("#", ""));
  },
  beforeMount: function () {
    this.fetchSessions();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/variables.scss";
h2,
h3,
h4,
h5 {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

h2 {
  font-family: Verdana;
  font-size: 20px;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
}

.background {
  color: black;
  background: url("https://res.cloudinary.com/oredev/image/upload/v1684918176/2023_web/Sessions_illustration_grain.jpg");
  background-repeat: no-repeat;
  background-position: top;
  background-size: contain;
  min-height: 30vh;
}
.background-mobile {
  color: black;
  background: url("https://res.cloudinary.com/oredev/image/upload/v1684918176/2023_web/Sessions_illustration_grain.jpg");
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  min-height: 50vh;
}

.open-in-new {
  text-align: right;
}
.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.days-headline {
  font-size: 16px !important;
  font-weight: 700;
}

.days span {
  //color: #000;
  cursor: pointer;
}
.days span.active {
  color: $orange !important;
  text-decoration: underline;
}

ul {
  margin: 0;
}
ul.dashed {
  list-style-type: disc;
}
/* ul.dashed > li {
  text-indent: -5px;
}
ul.dashed > li:before {
  content: "-";
  text-indent: -5px;
}
 */
.btn-active {
  background: $orange !important;
  color: white !important;
}

@media screen and (min-width: 1200px) {
  .container {
    padding-bottom: 135px;
  }
}

.session {
  z-index: 10;
  position: relative;
}

.rectangle-long-1 {
  width: 100%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  bottom: -196%;
  left: 0;
}
.rectangle-long-2 {
  width: 100%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  top: 100%;
  left: 0;
}

.rectangle-green-short,
.rectangle-orange {
  mix-blend-mode: color !important;
}
#green-2 {
  bottom: 50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 51%;
}
#green-3 {
  bottom: 29%;
  left: 0;
  max-width: 80%;
  z-index: 0;
}
#green-4 {
  bottom: 17.5%;
  max-width: 58%;
  z-index: 1;
  right: 0;
}
#green-5 {
  bottom: -80%;
  left: 0;
  max-width: 80%;
  z-index: 0;
}
#green-6 {
  bottom: -130%;
  max-width: 58%;
  z-index: 1;
  right: 0;
}
#orange-3 {
  bottom: -50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 51%;
}
#orange-4 {
  bottom: -110%;
  left: 0;
  width: 60%;
  height: 16px;
  z-index: 0;
}

#white-shape-1 {
  right: 30px;
  bottom: 75%;
}
#white-shape-2 {
  right: 35px;
  bottom: 71%;
}
#white-shape-2-mobile {
  right: 35px;
  bottom: 64%;
}
#white-shape-3 {
  right: 0;
  bottom: 37%;
  width: 16%;
}
#white-shape-4 {
  left: 3%;
  bottom: 37%;
}
#white-shape-5 {
  left: 3%;
  bottom: 7%;
  width: 17%;
}
#white-shape-6 {
  right: 3%;
  bottom: -22%;
}
#white-shape-7 {
  left: 3%;
  bottom: 5%;
}
#white-shape-8 {
  right: 3%;
  bottom: 13%;
}

.btn-1 {
  background-color: #f2f2eb !important;
}
.btn-1-active {
  background: $orange !important;
}

@media (max-width: 767px) {
  .btn-1 {
    width: 90px !important;
    float: right;
  }
}

.btn-1:hover {
  background: $orange !important;
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Sessions.vue